import { Navigation } from '../components/navigation/Navigation';
import { Outlet } from 'react-router-dom';
import { Container } from '@mantine/core';
import classes from './BaseLayout.module.css';
import Footer from './Footer';

export const BaseLayout = () => {
  return (
    <div className={classes.container}>
      <header className={classes.header}>
        <Container size="lg" className={classes.headerContent}>
          <Navigation />
        </Container>
      </header>

      <main className={classes.main}>
        <Outlet />
      </main>

      <Footer />
    </div>
  );
};
